import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_WIDTH = 16;
const DEFAULT_HEIGHT = 16;

function IconSplitToSection({ width, color }: Omit<IconProps, "height" | "class">) {
    const height = width! * DEFAULT_HEIGHT / DEFAULT_WIDTH;

    return (
        <svg width={width} height={height} viewBox="0 0 16 16">
            <g fill={color} fill-rule="evenodd">
                <rect fill-opacity=".35" x="5" width="2" height="7" rx="1"/>
                <rect x="5" y="9" width="2" height="7" rx="1"/>
            </g>
        </svg>
    );
}

IconSplitToSection.defaultProps = {
    width: DEFAULT_WIDTH,
    color: "var(--teflon)"
};

export default IconSplitToSection;
